<section class="verificacao-seguranca">
  <div class="verificacao-seguranca__box">
    <div class="verificacao-seguranca__header">
      <img src="assets/images/logo_omni_dark.svg" width="120" alt="logo" />
    </div>

    <div class="verificacao-seguranca__content" [ngSwitch]="statusVerificacaoAtual">
      <app-bem-vindo *ngSwitchCase="statusVerificacao.BEMVINDO"></app-bem-vindo>

      <app-verificacao-seguranca-identificacao
        (cpf)="changeCpf($event)"
        *ngSwitchCase="statusVerificacao.IDENTIFICACAO"
      ></app-verificacao-seguranca-identificacao>

      <app-termos
        (scrEvent)="scr = $event"
        (termosDeUsoEvent)="termosDeUso = $event"
        *ngSwitchCase="statusVerificacao.VERIFICAR"
      ></app-termos>

      <app-before-selfie
        *ngSwitchCase="statusVerificacao.BEFORE_SELFIE"
      ></app-before-selfie>

      <app-done *ngSwitchCase="statusVerificacao.DONE"></app-done>

      <app-expired-link
        *ngSwitchCase="statusVerificacao.EXPIRED"
      ></app-expired-link>
    </div>

    <div class="verificacao-seguranca__footer">
      <div>
        <button
          *ngIf="status === statusVerificacao.BEFORE_SELFIE"
          class="btn btn-border-orange verificacao-seguranca__footer_dica-selfie"
          (click)="onClickDicaFotoSelfie()"
          type="button"
        >
          <label>VER DICAS PARA A FOTO</label>
        </button>
      </div>

      <app-gradient-button
        *ngIf="
          status !== statusVerificacao.DONE &&
          status !== statusVerificacao.EXPIRED
        "
        label="CONTINUAR"
        [isDisabled]="isDisabledButtonClick"
        (click)="onClickNext()"
      >
      </app-gradient-button>
    </div>
  </div>
</section>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
